import { ChangeEvent } from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { getTimes } from 'utils/input-helper'
export type TimeInputProps = {
    defaultValue?: string
    onChange?(e: ChangeEvent): void
    id: string
    name: string
}
export function TimeInput(p: TimeInputProps) {
    const times = getTimes()
    return (
        <select
            id={p.id}
            name={p.name}
            className="focus:ring-primary-light focus:border-primary-light shadow-sm border-gray-300 rounded-md text-sm"
            onChange={p.onChange}
            defaultValue={p.defaultValue}
        >
            {times.map(({ text, value }) => (
                <option key={value} value={value}>
                    {text}
                </option>
            ))}
        </select>
    )
}
export default function DateInput(p: ReactDatePickerProps) {
    return (
        <DatePicker {...p} className={p.className} />
    )
}
